// extracted by mini-css-extract-plugin
export default {"root":"_1-Psg","content":"vVGaw","title":"_3UfIV","description":"_1xDIl"};